import { useWebSocketMessage } from '@features/websocket'

import { useFeatureFlags } from '@context/FeatureFlagsContext'

import type { WebSocketMessageHandler } from '../core/types'
import { isTransactionWebSocketMessage } from './transactionEvent'

export const useTransactionWebSocketMessage = (
  handler: WebSocketMessageHandler,
  enabled = true
): void => {
  const { websockets } = useFeatureFlags()

  useWebSocketMessage(isTransactionWebSocketMessage, handler, {
    enabled: enabled && websockets,
  })
}
